import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useCallback } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { useDropzone } from 'react-dropzone';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import DropIndicator from 'components/DropIndicator';
import { setAlert } from 'actions/alerts';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var OpenLink = function OpenLink(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(TextLink, {
    as: "span",
    children: children
  });
};
function SubtitlesUploader(_ref2) {
  var onSelect = _ref2.onSelect;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    file = _useState2[0],
    setFile = _useState2[1];
  var selectFile = useCallback(function (acceptedFiles, rejectedFiles) {
    if (rejectedFiles.length) {
      setAlert({
        title: t('error_subtitles_vtt_format')
      });
      return;
    }
    if (acceptedFiles.length) {
      var _acceptedFiles = _slicedToArray(acceptedFiles, 1),
        selectedFile = _acceptedFiles[0];
      setFile(selectedFile);
      onSelect(selectedFile);
    }
  }, [onSelect, t]);
  var _useDropzone = useDropzone({
      multiple: false,
      accept: '.vtt',
      onDrop: selectFile
    }),
    getRootProps = _useDropzone.getRootProps,
    getInputProps = _useDropzone.getInputProps,
    isDragActive = _useDropzone.isDragActive,
    isDragReject = _useDropzone.isDragReject;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, getRootProps()), {}, {
    children: /*#__PURE__*/_jsxs(Text, {
      as: "div",
      size: "s",
      children: [/*#__PURE__*/_jsx("input", _objectSpread({}, getInputProps())), /*#__PURE__*/_jsxs(DropIndicator, {
        textAlign: "center",
        p: "xs",
        isDragActive: isDragActive,
        isDragReject: isDragReject,
        children: [isDragActive && t('subtitles_file_drop_to_upload'), !isDragActive && file && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Text, {
            bold: true,
            as: "p",
            children: file.name
          }), /*#__PURE__*/_jsxs(Trans, {
            t: t,
            i18nKey: "subtitles_drop_and_replace",
            children: [/*#__PURE__*/_jsx(OpenLink, {
              children: "Click"
            }), " or drag and drop to replace"]
          })]
        }), !isDragActive && !file && /*#__PURE__*/_jsxs(Trans, {
          t: t,
          i18nKey: "subtitles_drop_and_upload",
          children: [/*#__PURE__*/_jsx(OpenLink, {
            children: "Click"
          }), " or drag and drop to upload subtitles (file format .vtt)."]
        })]
      })]
    })
  }));
}
export default SubtitlesUploader;